import $ from 'jquery'
let filterName = '';

if($('.recent-cases-list').length > 0) {
    const currentCaseId = localStorage.getItem('current_case');
    if (currentCaseId) {
        showCaseById(currentCaseId);
    }
    
    $('.case-category-item').on('click', function() {
        filterName = $(this).data('name');

        // Remove active class from all filters and cases
        $('.case-category-item').removeClass('active');
        $('.recent-case-item').removeClass('active');

        if (filterName === undefined || filterName === 'all') {
            // If "View All" is clicked
            $('.recent-case-item').addClass('active');
            $(this).addClass('active');
        } else {
            // If a specific filter is clicked
            $(this).addClass('active');
            $('.recent-case-item').each(function() {
                if ($(this).data('name').includes(filterName)) {
                    $(this).addClass('active');
                }
            });
        }
    });

    $('.recent-case-item').on('click', function(e) {
        e.preventDefault();

        // Get the data-id of the clicked recent case item
        const caseId = $(this).closest('.recent-case-item').data('id');
        $('.recent-cases-list_cases').addClass('content');

        // Add 'active' class to the matching recent-case-content element
        $('.recent-case-content').each(function() {
            if ($(this).data('id') === caseId) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });

        // Add 'hidden' class to all recent-case-item elements
        $('.recent-case-item').removeClass('active');

        $('html, body').animate({
            scrollTop: $('.recent-cases-list_cases').offset().top - 200
        }, 200);
    });

    $('.recent-case-content_back').on('click', function(e) {
        e.preventDefault();

        // Remove 'current_case' from localStorage
        localStorage.removeItem('current_case');

        // Remove 'active' class from all recent-case-content elements
        $('.recent-case-content').removeClass('active');

        // Show only recent-case-items with matching filterName
        if (filterName !== '') {
            $('.recent-case-item').each(function() {
                if ($(this).data('name') === filterName) {
                    $(this).addClass('active');
                } else {
                    $(this).removeClass('active');
                }
            });
        } else {
            // Show all recent-case-item elements
            $('.recent-case-item').addClass('active');
        }

        // Remove 'content' class from recent-cases-list_cases
        $('.recent-cases-list_cases').removeClass('content');
    });

    function showCaseById(caseId) {
        $('.recent-cases-list_cases').addClass('content');

        // Add 'active' class to the matching recent-case-content element
        $('.recent-case-content').each(function() {
            if ($(this).data('id') == caseId) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });

        // Add 'hidden' class to all recent-case-item elements
        $('.recent-case-item').removeClass('active');

        $('html, body').animate({
            scrollTop: $('.recent-cases-list_cases').offset().top - 200
        }, 200);
    }
}

//recent cases slider
$('.swiper-slide .recent-case-item, .info-small-item-case').on('click', function(e) {
    localStorage.setItem('current_case', $(e.currentTarget).data('id'));
});